import Button from '../button/button';
import { Icon } from '../icon/icon';
import cls from './icon-button.module.scss';
import { type IconButtonProps } from './icon-button.types';

const IconButton: React.FC<IconButtonProps> = props => {
  const {
    onClick,
    pathToIcon,
    iconSize = 14,
    theme,
    tone,
    className,
    disabled,
    dense,
    'aria-label': ariaLabel,
  } = props;

  const buttonClassName = [cls.iconButton, dense ? cls.dense : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Button
      onClick={onClick}
      className={buttonClassName}
      theme={theme}
      tone={tone}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <Icon pathToIcon={pathToIcon} size={iconSize} />
    </Button>
  );
};

export default IconButton;
